/* eslint-disable security/detect-object-injection */
import React, { useContext } from 'react';
import AnimatedImage from '../../components/Animations/AnimatedImage';
import ApplicationContext from '../../context/ApplicationContext';
import { insuranceLanguageContent } from './InsuranceLanguageContent';

function InsuranceHeader(props) {
    const { selectedLanguage } = useContext(ApplicationContext);
    return (
        <p className='text-center font-semibold text-[#64A003] text-[24px] border-b border-[#D7D7D7] py-[8px] lg:text-[26px] xl:text-[32px] 2xl:text-[38px] flex justify-center items-center pb-[5px]'>
            <AnimatedImage url="/images/Umbrella.svg" alt="insurance" className="mr-[12px]" />
            {insuranceLanguageContent['insurance'][selectedLanguage]}
        </p>
    );
}

export default InsuranceHeader;